
import * as React from "react";
import { Helmet } from "react-helmet-async";
import { PaletteMode } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
// import Divider from "@mui/material/Divider";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import AppAppBar from "../../components/layout/AppAppBar";
import Hero from "../../components/landing/Hero";
import FAQ from "../../components/landing/FAQ";
import Footer from "../../components/layout/Footer";
import getLPTheme from "../../getLPTheme";
import Testimonials from "../../components/landing/Testimonials";
import OfferSection from "../../components/offers/OfferSection";
import CounterSection from "../../components/landing/Counter";
import HowItWorks from "../../components/landing/HowItWorks";
import SecurityBadges from "../../components/landing/SecurityBadges";
import PayBanner from "../../components/common/PayBanner";



export default function LandingPage() {
  const [mode, setMode] = React.useState<PaletteMode>("light");
  // const [showCustomTheme, setShowCustomTheme] = React.useState(true);
  const LPtheme = createTheme(getLPTheme(mode));
  // const [showFloater, setShowFloater] = React.useState(false);
  // const [amount, setAmount] = React.useState(0);
  const [isBannerVisible, setIsBannerVisible] = React.useState(false);
  // const [isMobile, setIsMobile] = React.useState(true); // Default to true to avoid flash

  // ✅ ADD STATE FOR SOURCE TRACKING
  // const [adSource, setAdSource] = React.useState<string | null>(null);

  const toggleColorMode = () => {
    setMode((prev) => (prev === "dark" ? "light" : "dark"));
  };

  const handleBannerStateChange = (isVisible: boolean) => {
    setIsBannerVisible(isVisible);
  };

  React.useEffect(() => {
    // Check if device is mobile (max width 768px for phones only)
    /* const checkMobile = () => {
      const isMobileDevice = window.innerWidth <= 768 &&
        /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      setIsMobile(isMobileDevice);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile); */

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      window.location.href = "/ios";
      return;
    }


    // const match = currentUrl.match(/\/(\d+)\/?$/);
    // const number = match ? parseInt(match[1], 10) : 0; // Unused

    // ✅ CAPTURE SOURCE PARAMETER FROM URL
    const urlParams = new URLSearchParams(window.location.search);
    const source = urlParams.get('source') || urlParams.get('utm_source');

    if (source) {
      sessionStorage.setItem('ad_source', source);
    }

    // ✅ CHECK FOR FB PATH OR SOURCE
    if (window.location.pathname === '/fb' || source === 'facebook') {
      sessionStorage.setItem('fb_user', 'true');
      sessionStorage.setItem('ad_source', 'facebook');
      localStorage.setItem('fb_user', 'true');
    } else if (window.location.pathname !== '/fb' && source !== 'facebook') {
      // If not on FB landing and no FB source in URL, we treat as potentially direct
      // Clear legacy localStorage to prevent "stuck" FB status for direct users
      localStorage.removeItem('fb_user');
      // Only clear session if we're at the root or a non-FB specific sub-page
      if (window.location.pathname === '/' || !window.location.pathname.startsWith('/fb')) {
        sessionStorage.removeItem('fb_user');
        if (sessionStorage.getItem('ad_source') === 'facebook') {
          sessionStorage.removeItem('ad_source');
        }
      }
    }

    // ✅ INSTALL RETURN LOGIC
    const checkInstallReturn = () => {
      const hasInitiatedInstall = localStorage.getItem('install_initiated');
      if (hasInitiatedInstall === 'true' && document.visibilityState === 'visible') {
        localStorage.removeItem('install_initiated');

        // Determine if FB user (Check session state)
        const isFbUser = sessionStorage.getItem('fb_user') === 'true' ||
          sessionStorage.getItem('ad_source') === 'facebook';

        if (isFbUser) {
          window.location.href = '/submit-task-fb';
        } else {
          window.location.href = '/submit-task';
        }
      }
    };

    // Check on mount
    checkInstallReturn();

    // Check on visibility change (when returning from Play Store)
    const handleVisibilityChange = () => {
      checkInstallReturn();
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // ✅ CHECK FOR PERSISTENT SESSION (Endless Cookie)
    const isLoggedIn = localStorage.getItem('is_logged_in') === 'true';
    if (isLoggedIn) {
      // Redirect to dashboard if user is already logged in
      window.location.href = '/dashboard';
      return;
    }

    // Handle scroll to hash from URL (e.g., #offers-section)
    const hash = window.location.hash;
    if (hash === '#offers-section') {
      setTimeout(() => {
        const element = document.getElementById('offers-section');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 300);
    }

    return () => {
      // window.removeEventListener('resize', checkMobile);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);



  return (
    <ThemeProvider theme={LPtheme}>
      <CssBaseline />
      <Helmet>
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://app20.co/" />
      </Helmet>
      <AppAppBar
        mode={mode}
        toggleColorMode={toggleColorMode}
        isBannerVisible={isBannerVisible}
        transparentMode={true}
        useTextLogo={false}
        simpleNavbar={true}
      />
      <PayBanner onBannerStateChange={handleBannerStateChange} />
      <Hero amount={0} />
      <Box sx={{ bgcolor: "background.default", marginTop: 0 }}>

        {/* Added HowItWorks component */}
        <HowItWorks />

        {/* Replaced SecondarySec usage */}
        <Box sx={{ width: "100%", mt: 2, mb: 0 }}>
          <OfferSection isPublicPage={true} />
        </Box>

        <CounterSection />

        <Box sx={{ height: 32 }} />

        <Testimonials />

        {/* Combined FAQ and Footer Section with Yellow Gradient Background */}
        <Box
          sx={{
            background: "linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 60%, #FFB300 100%)", // White top -> White mid -> Yellow Footer
            pt: 0,
            pb: 0,
            mt: 0
          }}
        >
          {/* Security Badges Section - Before FAQ */}
          <SecurityBadges />

          <FAQ />
          {/* {showFloater && <Floater />} */}
          <Footer />
        </Box>
      </Box>
    </ThemeProvider>
  );
}